<template>
    <div>
        <DraggableTiles
            ref="DraggableTiles"
            :tilesProp="tiles"
            :storeModule="layoutStore"
            :version="version"
        />
    </div>
</template>
<script>
import DraggableTiles from "@/components/UIComponents/DraggableTileDashboard.vue";
import {checkforReadyStepsCoach} from 'src/util/ReadyStepsCheck'

export default {
    components: {
        DraggableTiles,
    },
    methods: {},
    data() {
        return {
            version: "8.006",
            layoutStore: this.$route.meta.draggableGridStoreModule,
            tiles: [
                {
                    name: "Account Metrics",
                    w: 1,
                    h: 1,
                    component: "AccountMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/AccountMetrics/AccountMetrics",
                    modal: {
                        width: "90%",
                        modalComponent: "AccountMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/AccountMetrics/AccountMetricsModal",
                    },
                },
                {
                    name: "Engagement Score",
                    w: 1,
                    h: 1,
                    component: "EngagementScoreMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/EngagementScoreMetrics/EngagementScoreMetrics",
                    modal: {
                        width: "80%",
                        modalComponent: "EngagementScoreMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/EngagementScoreMetrics/EngagementScoreMetricsModal",
                    },
                },
                {
                    name: "Outreach Score",
                    w: 1,
                    h: 1,
                    component: "PatientInteractionScoreMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/PatientInteraction/PatientInteractionScoreMetrics",
                    modal: {
                        width: "80%",
                        modalComponent: "PatientInteractionScoreMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/PatientInteraction/PatientInteractionScoreMetricsModal",
                    },
                },
                {
                    name: "Login Metrics",
                    w: 1,
                    h: 1,
                    component: "LoginMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/LoginMetrics/LoginMetrics",
                    modal: {
                        width: "80%",
                        modalComponent: "LoginMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/LoginMetrics/LoginMetricsModal",
                    },
                },
                {
                    name: "Weight Metrics",
                    w: 1,
                    h: 1,
                    component: "WeightMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/WeightMetrics/WeightMetrics",
                    modal: {
                        width: "95%",
                        modalComponent: "WeightMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/WeightMetrics/WeightMetricsModal",
                    },
                },
                {
                    name: "ColorMyDayMetrics",
                    w: 1,
                    h: 1,
                    component: "ColorMyDay",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/ColorMyDayMetrics/ColorMyDay",
                    modal: {
                        width: "80%",
                        modalComponent: "ColorMyDayModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/ColorMyDayMetrics/ColorMyDayModal",
                    },
                },
                {
                    name: "Inbox",
                    w: 1,
                    h: 1,
                    component: "InboxTile",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/Inbox/InboxTile",
                    modal: {
                        width: "80%",
                        modalComponent: "InboxModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/Inbox/InboxModal",
                    },
                },
                {
                    name: "RPM",
                    w: 1,
                    h: 1,
                    component: "RPM",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/RPM/RPM",
                    modal: {
                        width: "95%",
                        modalComponent: "RPMModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/RPM/RPMModal",
                    },
                },
                {
                    name: "Customers",
                    w: 1,
                    h: 1,
                    component: "CustomerMetrics",
                    componentProps: {},
                    componentPath:
                        "components/Dashboard/Views/Dashboard/Widgets/CustomerMetrics/CustomerMetrics",
                    modal: {
                        width: "90%",
                        modalComponent: "CustomerMetricsModal",
                        modalComponentPath:
                            "components/Dashboard/Views/Dashboard/Widgets/CustomerMetrics/CustomerMetricsModal",
                    },
                },
            ],
        };
    },
    created() {
        if(checkforReadyStepsCoach() == true) {
            var readyStepsCoachingTile = {
                name: "ReadyStepsCoaching",
                w: 1,
                h: 1,
                component: "ReadyStepsTile",
                componentProps: {},
                componentPath: "components/Dashboard/Views/Dashboard/Widgets/ReadySteps/ReadyStepsTile",
                modal: {
                    width: "98%",
                    modalComponent: "ReadyStepsModal",
                    modalComponentPath: "components/Dashboard/Views/Dashboard/Widgets/ReadySteps/ReadyStepsModal"
                }
            }
            this.tiles.push(readyStepsCoachingTile)
        }
    }
};
</script>
<style scoped>
</style>
